import { useMutation } from '@tanstack/react-query'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { postData } from 'src/api/api-utilities'
import { isValidRedirectUrl } from 'src/utils/helpers/RedirectHelpers'

const postSignIn = async (params) => {
  const response = await postData('/users/sign_in', { user: { ...params } })
  return response
}

const handlePostLoginRedirect = (navigate, redirectUrl, tempPassword) => {
  if (tempPassword) {
    // update-password
    const updatePasswordUrl = redirectUrl
      ? `/auth/update-password?redirect=${encodeURIComponent(redirectUrl)}`
      : '/auth/update-password'
    navigate(updatePasswordUrl)
  } else if (redirectUrl && isValidRedirectUrl(redirectUrl)) {
    // redirect preserving UTM parameters
    window.location.href = redirectUrl
  } else {
    // default redirect
    navigate('/programs', { state: { fromLogin: true } })
  }
}

const useLogin = () => {
  const navigate = useNavigate()
  const { mutateAsync, mutate, isPending } = useMutation({
    mutationFn: postSignIn,
    onSuccess: (data, vars) => {
      if (data.status === 200) {
        // Set authentication cookies with safety checks
        const responseData = data.data || {}
        const { auth_token: authToken, email, temp_password: tempPassword } = responseData
        Cookies.set('token', authToken)
        Cookies.set('email', email)

        handlePostLoginRedirect(navigate, vars.redirectUrl, tempPassword)
      }
    }
  })

  return { mutateAsync, mutate, isLoading: isPending }
}

export default useLogin
